import type { ErrorLink } from '@apollo/client/link/error';
import type { OperationDefinitionNode } from 'graphql';
import { print } from 'graphql';

import { DEFAULT_MASK_VALUE, maskValuesInObject } from './objUtils';

const KEYS_TO_MASK = ['password', 'sin'];

const getOperationDefinition = (operation: ErrorLink.ErrorHandlerOptions['operation']) =>
  operation.query.definitions.find(q => q.kind === 'OperationDefinition') as OperationDefinitionNode;

export const getOperationData = (operation: ErrorLink.ErrorHandlerOptions['operation']) => {
  const operationDefinition = getOperationDefinition(operation);
  const type = operationDefinition.operation;
  const query = print(operationDefinition);
  const maskedVariable = maskValuesInObject(operation.variables || {}, KEYS_TO_MASK, DEFAULT_MASK_VALUE);

  return {
    name: operation.operationName,
    query,
    type,
    variables: maskedVariable,
  };
};

export const isNetworkStatusCodeIgnored = (statusCode: number | string) => [502].includes(Number(statusCode));
